/**
 * Shared Highcharts ESM entry for Vite. Product modules must import from
 * `highcharts/esm/...` so they attach to this instance (UMD module paths break
 * under the 13.0.1 `module` field with SeriesRegistry errors).
 */
import Highcharts from 'highcharts/esm/highcharts.js';

// Highcharts defaults to `color-scheme: light dark`, which follows the OS setting. The sui-tokens 5
// colors use `light-dark()`, so charts must inherit the app's color mode instead.
Highcharts.setOptions({ palette: { colorScheme: 'inherit' } });

export default Highcharts;
